<!--
Auto-generated by: https://github.com/threlte/threlte/tree/main/packages/gltf
Command: npx @threlte/gltf@2.0.3 /Users/nrumak/Development/square-dt-labs/static/nrumak/T2_modified.glb -u -t -P
-->

<script module lang="ts">
  import { Group, Material, Mesh } from 'three';
  import { T, type Props } from '@threlte/core';
  import { useGltf, useSuspense } from '@threlte/extras';
  import type { Snippet } from 'svelte';

  const scale = 4;

  type GLTFResult = {
    nodes: {
      Mesh002: Mesh;
      Mesh002_1: Mesh;
      Mesh002_2: Mesh;
      Mesh002_3: Mesh;
    };
    materials: {};
  };

  let modelUrl = '';

  const load = () => {
    const suspend = useSuspense();
    return suspend(useGltf<GLTFResult>(modelUrl));
  };

  export const preload = async (url: string) => {
    modelUrl = url;
    try {
      await load();
    } catch (err) {
      return console.error('Failed to load model', err);
    }
  };
</script>

<script lang="ts">
  let {
    fallback,
    error,
    children,
    ref = $bindable(),
    matcaps,
    fallbackMaterial,
    ...props
  }: Props<Group> & {
    ref?: Group;
    matcaps: {
      blackFrame: Material;
      t2Glass: Material;
      whitePlastic: Material;
      t2_screen: Material;
    };
    fallbackMaterial: Material;
    children?: Snippet<[{ ref: Group | undefined }]>;
    fallback?: Snippet;
    error?: Snippet<[{ error: Error }]>;
  } = $props();

  let materials: any = $state(matcaps);

  $effect(() => {
    materials = matcaps ?? {
      t2Glass: fallbackMaterial,
      blackFrame: fallbackMaterial,
      whitePlastic: fallbackMaterial,
      t2_screen: fallbackMaterial,
    };
  });
  const gltf = load();
</script>

<T is={new Group()} bind:ref dispose={false} {...props} {scale}>
  {#await gltf}
    {@render fallback?.()}
  {:then gltf}
    <T.Group rotation={[Math.PI / 2, 0, 0]} scale={0.01}>
      <T.Mesh geometry={gltf.nodes.Mesh002.geometry} material={materials.t2_screen} />
      <T.Mesh geometry={gltf.nodes.Mesh002_1.geometry} material={materials.whitePlastic} />

      <T.Mesh geometry={gltf.nodes.Mesh002_2.geometry} material={materials.blackFrame} />
      <T.Mesh geometry={gltf.nodes.Mesh002_3.geometry} material={materials.t2Glass} position={[0, 0, -0.03]} />
    </T.Group>
  {:catch err}
    {@render error?.({ error: err })}
  {/await}
  {@render children?.({ ref })}
</T>
